import React from "react";
import { profile } from "../data/profile";

function OverviewText({ mounted }) {
  return (
    <div>
      <div className={`overview-name ${mounted ? "is-mounted" : ""}`}>
        {profile.firstName}
        <br />
        {profile.lastName}
      </div>
      <div className="overview-details">
        <div>
          <div>FULL-STACK &amp; AI DEVELOPER</div>
          <div>CODEIGNITER · REACT · FLUTTER · CV</div>
        </div>
        <div className="overview-location">
          <div>{profile.location.toUpperCase().replace(", INDONESIA", "")}</div>
          <a href={`mailto:${profile.email}`}>{profile.email}</a>
        </div>
      </div>
    </div>
  );
}

export default OverviewText;
